<template>
    <div>
        <validation-provider v-slot="{ errors }" :rules='required ? "required" : "" ' :name="label">
            <v-textarea
                    counter
                    auto-grow
                    ref="refEl"
                    rows="4"
                    row-height="15"
                    v-model="myValue"
                    :class="[classExtra ]"
                    :maxlength="1024"
                    :minlength="minlength"
                    :disabled="disabled"
                    :placeholder="placeholder"
                    :outlined="outlined"
                    :label="label"
                    :clearable="clearable"
                    :readonly="readonly"
                    :error-messages="errors"
                    :validate-on-blur="true"
                    @change="$emit('searchInput', {data: myValue,
                        name: nameRef,
                        event: eventModel
                  })"
                    @keydown.enter="$emit('searchInput', {data: myValue,
                        name: nameRef,
                        event: eventModel
                  })"
            >
                <template  v-slot:label>
                    {{ label }}<span v-if="required " style="color: red;margin-left: 2px;">*</span>
                </template>
            </v-textarea>
        </validation-provider>
    </div>
</template>
<script>
import { COMMON_PROPS_INPUT } from "@/pages/teacher-support/constaint/input";

export default {
    name: "BaseTextarea",
    props: { ...COMMON_PROPS_INPUT },
    data(){
        return {
            myValue: '',
        }
    },
    created() {
        this.myValue = this.value
    },
    watch: {
        myValue() {
            this.$emit('input', this.myValue)
        },
        value(valueData) {
            if (!valueData || valueData.toString().trim().length === 0) {
                this.myValue = ''
            } else {
                this.myValue = valueData.trimStart()
            }
        },

    },
}
</script>